<template>
  <div class="w-[155px]">
    <p
      :for="uuid"
      class="text-[10px] text-charcoal uppercase font-normal leading-[normal] mb-[8px]"
    >
      {{ title }}
    </p>
    <div class="flex justify-between items-start gap-x-[13px]">
      <div class="flex justify-between first-letter:between gap-x-[5px]">
        <div class="flex items-center flex-col gap-[2px]">
          <input
            :id="uuid"
            v-model="hour"
            type="text"
            placeholder="00"
            class="w-[43px] h-[41px] px-[12px] py-[8px] text-charcoal border border-grey-pale rounded-[5px] focus:border-easy-blue focus:outline-0 focus:ring-2 focus:ring-blue-500"
            @input="handleHour"
          />
          <span class="text-[9px] leading-[normal] text-charcoal">Hours</span>
        </div>
        <span class="mt-[8px]">:</span>
        <div class="flex items-center flex-col gap-[2px]">
          <input
            v-model="minute"
            type="text"
            placeholder="00"
            class="w-[43px] h-[41px] px-[12px] py-[8px] text-charcoal border border-grey-pale rounded-[5px] focus:border-easy-blue focus:outline-0 focus:ring-2 focus:ring-blue-500"
            @input="handleMinute"
          />
          <span class="text-[9px] leading-[normal] text-charcoal">Minute</span>
        </div>
      </div>
      <div class="flex flex-col">
        <span
          class="w-[43px] h-[20.5px] text-[11px] bg-white text-grey-mid font-normal leading-[18px] tracking-[-0.11px] text-center rounded-t-[5px] border border-b-0 border-grey-pale cursor-pointer"
          :class="{ '!bg-blue text-white': meridiem == 'AM' }"
          @click="handleMeridiem('AM')"
          >AM</span
        >
        <span
          class="w-[43px] h-[20.5px] text-[11px] bg-white text-grey-mid font-normal leading-[18px] tracking-[-0.11px] text-center rounded-b-[5px] border border-grey-pale cursor-pointer"
          :class="{ '!bg-blue text-white': meridiem == 'PM' }"
          @click="handleMeridiem('PM')"
          >PM</span
        >
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue';

import _ from 'lodash';
const uuid = _.uniqueId('time-counter-hour-');

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
});

watch(
  () => props.modelValue,
  (newVal) => {
    setTime(newVal);
  }
);
const hour = ref(null);
const minute = ref(null);
const meridiem = ref(null);

const formatValue = (value, maxValue, minValue = 0) => {
  value = parseInt(value, 10);

  if (isNaN(value) || value < minValue) return '0' + minValue;
  if (value > maxValue) return maxValue.toString().padStart(2, '0');

  return value.toString().padStart(2, '0');
};

const handleHour = () => {
  hour.value = formatValue(hour.value, 12, 1);
  emitTime();
};

const handleMinute = () => {
  minute.value = formatValue(minute.value, 59);
  emitTime();
};

const handleMeridiem = (mer) => {
  meridiem.value = mer;

  emitTime();
};

const time = computed(() => {
  return `${hour.value}:${minute.value} ${meridiem.value}`;
});

import moment from 'moment';
const isValidFrom = computed(() => {
  return moment(props.modelValue, 'HH:mm').isValid();
});
const isValidTo = computed(() => {
  const timePattern = /^(0[1-9]|1[0-2]):([0-5][0-9])\s?(AM|PM)$/;

  return timePattern.test(time.value);
});
const setTime = (time) => {
  if (isValidFrom.value) {
    hour.value = moment(time, 'HH:mm').format('hh');
    minute.value = moment(time, 'HH:mm').format('mm');
    meridiem.value = moment(time, 'HH:mm A').format('A');
  }
};

const emitTime = () => {
  if (isValidTo.value) {
    emit('update:modelValue', moment(time.value, 'HH:mm A').format('HH:mm:00'));
  }
};

onMounted(async () => {
  setTime(props.modelValue);
});
</script>
